var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',{staticClass:"avatar",class:{medium: _vm.size === 'medium', small: _vm.size === 'small'}},[(_vm.user?.portrait)?_c('img',{attrs:{"src":`${_vm.portrait_url}`,"alt":""}}):_c('span',[_vm._v(_vm._s(_vm.user?.username?.[0].toUpperCase() || ""))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }